import { Mail, Reply, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export const ContactMessagesPanel = ({ data, reload, formatDate }) => {
  const act = async (fn, okMsg) => {
    try {
      await fn();
      toast.success(okMsg);
      reload();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="mt-6" data-testid="contact-messages-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border bg-card p-5">
        <div>
          <p className="text-sm font-semibold text-slate-900">Pertanyaan Hubungi Kami</p>
          <p className="mt-1 text-xs text-slate-500">
            Semua mesej dari borang /hubungi. Emel juga dihantar ke info@direktoribiz.my.
          </p>
        </div>
        <Badge data-testid="contact-unread-count" className="bg-primary/10 text-primary">
          {data.unread} belum dibaca
        </Badge>
      </div>

      {data.items.length === 0 ? (
        <p data-testid="contact-messages-empty" className="mt-6 rounded-lg border border-dashed border-border p-10 text-center text-sm text-slate-500">
          Belum ada pertanyaan.
        </p>
      ) : (
        <div className="mt-6 space-y-4" data-testid="contact-messages-list">
          {data.items.map((m) => (
            <div
              key={m.id}
              data-testid={`contact-message-${m.id}`}
              className={`rounded-lg border bg-card p-5 ${m.read ? "border-border" : "border-primary/40 bg-primary/[0.03]"}`}
            >
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-semibold text-slate-900">
                    {m.subject}
                    {!m.read && (
                      <Badge className="ml-2 bg-primary text-[10px] text-white">Baharu</Badge>
                    )}
                  </p>
                  <p className="mt-1 text-xs text-slate-500">
                    {m.name} · {m.email}
                    {m.phone ? ` · ${m.phone}` : ""} · {formatDate(m.created_at)}
                  </p>
                </div>
                <div className="flex gap-2">
                  <a href={`mailto:${m.email}?subject=${encodeURIComponent("RE: " + m.subject)}`}>
                    <Button size="sm" variant="outline" data-testid={`contact-reply-${m.id}`}>
                      <Reply className="mr-1.5 h-3.5 w-3.5" /> Balas
                    </Button>
                  </a>
                  {!m.read && (
                    <Button
                      size="sm"
                      variant="outline"
                      data-testid={`contact-mark-read-${m.id}`}
                      onClick={() => act(() => api.post(`/admin/contact-messages/${m.id}/read`), "Ditanda sudah dibaca")}
                    >
                      <Mail className="mr-1.5 h-3.5 w-3.5" /> Tanda dibaca
                    </Button>
                  )}
                  <Button
                    size="sm"
                    variant="outline"
                    data-testid={`contact-delete-${m.id}`}
                    className="text-red-600 hover:bg-red-50"
                    onClick={() => act(() => api.delete(`/admin/contact-messages/${m.id}`), "Mesej dipadam")}
                  >
                    <Trash2 className="h-3.5 w-3.5" />
                  </Button>
                </div>
              </div>
              <p className="mt-3 whitespace-pre-wrap text-sm leading-relaxed text-slate-700">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
